import { Alert, Box, Grid } from "@mui/material";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import useConfirm from "../../../hooks/useConfirm";
import { useQuery } from "../../../hooks/useQuery";
import CandidatureService from "../../../services/CandidatureService";
import { DomaineParAMIService } from "../../../services/candidature/DomaineParAMIService";
import { LocalisationService } from "../../../services/candidature/LocalisationService";
import AmiInfoResume from "./resume/AmiInfoResume";
import DomaineSouDomaineResume from "./resume/DomaineSouDomaineResume";
import ListLocalisationResume from "./resume/ListLocalisationResume";

const Resume = forwardRef(({ id_type }, ref) => {
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const url_candidature = "https://recrutement.fid-server.org/";
  const [data, setData] = useState({
    ami_info: null,
    load_ami_info: false,
    lien_publication: url_candidature,
    diplom_min_requis: null,
    domaine_sous_domaine_list: [],
    load_sous_domaine_list: false,
    localisation_list: [],
    load_localisation_list: false,
  });
  const url = useQuery();
  const handleValidate = async () => {
    openConfirmDialog(
      "Finalisation de la creation d'AMI",
      "Voulez-vous valider cette AMI ?",
      () => {
        return true;
      },
    );
  };
  useImperativeHandle(ref, () => ({
    save: async () => true,
    // save: handleValidate,
  }));

  const idType = url.get("id_type");

  const handleFetchAmiInfo = useCallback(() => {
    setData((prevData) => ({ ...prevData, load_ami_info: true }));
    CandidatureService.find_one(idType)
      .then((response) => {
        if (response && response.data) {
          setData((prevData) => ({
            ...prevData,
            ami_info: response.data,
            lien_publication:
              response.data?.type === "interne"
                ? url_candidature
                : url_candidature + "consultant-externe",
          }));
        }
      })
      .finally(() => {
        setData((prevData) => ({ ...prevData, load_ami_info: false }));
      });
  }, [idType]);

  const handleFetchSousDomaineList = useCallback(() => {
    setData((prevData) => ({ ...prevData, load_sous_domaine_list: true }));
    DomaineParAMIService.lister({ id_type: idType })
      .then((response) => {
        if (response && response.data) {
          setData((prevData) => ({
            ...prevData,
            domaine_sous_domaine_list: response.data,
            load_sous_domaine_list: false,
          }));
        }
      })
      .finally(() => {
        setData((prevData) => ({ ...prevData, load_sous_domaine_list: false }));
      });
  }, [idType]);

  const handleFetchLocalisationList = useCallback(() => {
    setData((prevData) => ({ ...prevData, load_localisation_list: true }));
    LocalisationService.lister({ id_type: idType })
      .then((response) => {
        setData((prevData) => ({
          ...prevData,
          localisation_list: response.data,
          load_localisation_list: false,
        }));
      })
      .finally(() => {
        setData((prevData) => ({ ...prevData, load_localisation_list: false }));
      });
  }, [idType]);

  useEffect(() => {
    handleFetchAmiInfo();
    handleFetchSousDomaineList();
    handleFetchLocalisationList();
  }, [
    handleFetchAmiInfo,
    handleFetchSousDomaineList,
    handleFetchLocalisationList,
  ]);

  return (
    <Box
      sx={{
        maxHeight: "70vh",
        overflow: "auto",
        p: { xs: 1.5, md: 2 },
        borderRadius: 2,
        backgroundColor: "#F4F6F8",
      }}
    >
      <DialogComponent />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert
            severity="info"
            variant="outlined"
            sx={{
              borderLeft: "solid 3px",
              borderColor: "primary.main",
              mb: 0,
            }}
          >
            <Grid  bgcolor={"#0a5)"}>
              <div
                dangerouslySetInnerHTML={{
                  __html: `L'AMI sera visible sur <b> ${data.lien_publication}</b>`,
                }}
              />
              {/* <IconButton
                size="small"
                color="primary"
                onClick={() =>
                  navigator.clipboard.writeText(data.lien_publication)
                }
              >
                <CopyAllOutlined />
              </IconButton> */}
            </Grid>
          </Alert>
        </Grid>

        <AmiInfoResume
          ami_detail={data.ami_info}
          loading={data.load_ami_info}
        />
        <DomaineSouDomaineResume
          domaine_sous_domaines={data.domaine_sous_domaine_list}
          loading={data.load_sous_domaine_list}
        />
        <ListLocalisationResume
          localisations={data.localisation_list}
          loading={data.load_localisation_list}
        />
      </Grid>
    </Box>
  );
});

export default Resume;
